import { Loader2 } from 'lucide-react';
import { AvisoPrivacidadTexto, useAvisoPrivacidad } from '@renderer/components/publico/AvisoPrivacidad';

/**
 * Sprint 167 — El aviso de privacidad en su propia dirección (`#/privacidad`), para mandarlo por
 * WhatsApp o ligarlo desde la página del pedido. Pública: no pide sesión, como el menú.
 */
export function AvisoPrivacidadPage() {
  const { aviso, error } = useAvisoPrivacidad();
  return (
    <div className="mx-auto min-h-screen max-w-lg bg-white px-5 py-6">
      {aviso ? (
        <AvisoPrivacidadTexto aviso={aviso} />
      ) : error ? (
        <p className="text-sm text-slate-700">No pudimos cargar el aviso. Inténtalo de nuevo en un momento.</p>
      ) : (
        <Loader2 className="mx-auto mt-10 h-6 w-6 animate-spin text-slate-500" />
      )}
    </div>
  );
}
